import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getSessionStorage, setSessionStorage } from "../../../helperFunctions/sessionStorage";

interface FilterState {
  platforms: string[];
}

// Define all available platforms
const ALL_PLATFORMS = ["all"];

const savedPlatforms = getSessionStorage("platforms");
console.log("saved plat",savedPlatforms)

const initialState: FilterState = {
  // If sessionStorage has data → use it, else default to ALL_PLATFORMS
  platforms: savedPlatforms && savedPlatforms.length > 0 ? savedPlatforms : ALL_PLATFORMS,
};

const platformSlice = createSlice({
  name: "platformFilter",
  initialState,
  reducers: {
    setPlatforms(state, action: PayloadAction<string[]>) {
      state.platforms = action.payload;
      setSessionStorage("platforms", action.payload); // save to sessionStorage
    },
    clearPlatforms(state) {
      state.platforms = [];
      setSessionStorage("platforms", []); // clear from sessionStorage
    },
  },
});

export const { setPlatforms, clearPlatforms } = platformSlice.actions;
export default platformSlice.reducer;
